module.exports = __webpack_public_path__ + "static/img/1619_phase_function_Paper_PointsHejduk_Prediction.0e1cd48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1619_phase_function_Paper_PointsHejduk_Prediction.png
// module id = YKM1
// module chunks = 0